import * as signalR from "@aspnet/signalr"
import {
  CommunicationParty,
  TrackableMessageDto,
  GetTotalUnReadCountRequest,
} from "@/types/interface/IM/IMTypes"
import store from "@/store"
import { getUnreadMessageCount } from "./net/im"
import { getOrderById } from "./net/order"
import { OrderStatus, OrderTab } from "@/types/enum/OrderEnum"
import { IOrderDto } from "@/types/interface/IOrderDto"
import { IOrderCancellationRequestDto } from "@/types/interface/IOrderCancellationRequestDto"

const noRequestIMCountPages: string[] = ["Messages", "Conversation"]

const refreshTimeLimit = (): boolean => {
  let lastTime: number = store.state.updateOrderListInSignalR
  let now = new Date().getTime()
  if (now - lastTime < 45000) {
    return false
  }
  store.commit("handleupdateOrderListInSignalR", now)
  return true
}

export const refreshTimeLimitMessage = (): boolean => {
  let lastTime: number = store.state.updateOrderListInSignalRMessageCount
  let now = new Date().getTime()
  if (now - lastTime < 45000) {
    return false
  }

  store.commit("handleupdateOrderListInSignalRMessageCount", now)
  return true
}

const refreshHistoryOrderList = async (event: any) => {
  if (!refreshTimeLimit() || store.state.inPreOrderTab) {
    return
  }
  let { OrderId: orderId } = event
  let historyOrder = store.state.historyOrder.find(
    (x: IOrderDto) => x.id === orderId
  )
  let order
  if (store.state.orderList.length) {
    order = store.state.orderList.find((x: IOrderDto) => x.id === orderId)
  } else {
    return
  }

  let showLoadding = false
  if (!order && !historyOrder) {
    return
  }
  order = order || historyOrder
  getOrderById(orderId, showLoadding)
  const orderStatus = getCurrentTabOrderStatus()
  await store.dispatch("handleOrderList", {
    page: store.state.currentOrderPage,
    orderStatus,
    keyword: store.state.keyword,
    noReplaceOrderList: true,
  })
}

const getCurrentTabOrderStatus = () => {
  const tab: string = store.state.currentOrderTab
  let orderStatus: number[]
  switch (tab) {
    case "Processing":
      orderStatus = [
        OrderStatus.WaitingForAcceptance,
        OrderStatus.Processing,
        OrderStatus.Ready,
        OrderStatus.Delivering,
      ]
      break
    case "PreOrder":
      orderStatus = [
        OrderStatus.Processing,
        OrderStatus.Ready,
        OrderStatus.Delivering,
      ]
      break
    case "Refunding":
      orderStatus = [OrderStatus.WaitingForAcceptance]
      break
    case "Incoming":
      orderStatus = [OrderStatus.WaitingForAcceptance]
      break
    case "Preparing":
      orderStatus = [OrderStatus.Processing]
      break
    case "Ready":
      orderStatus = [OrderStatus.Ready]
      break
    case "Delivering":
      orderStatus = [OrderStatus.Delivering]
      break
    case "Completed":
      orderStatus = [
        OrderStatus.Completed,
        OrderStatus.CancelRejected,
        OrderStatus.Cancelled,
      ]
      break
    case "Rejected":
      orderStatus = [OrderStatus.Rejected]
      break
    default:
      orderStatus = []
      break
  }
  return orderStatus
}

const handleOrderList = async () => {
  const orderStatus = getCurrentTabOrderStatus()
  if (store.state.inPreOrderTab && store.state.preOrderDate) {
    await store.dispatch("handlePreOrderList", {
      page: store.state.currentOrderPage,
      orderStatus,
      keyword: store.state.keyword,
      date: store.state.preOrderDate,
    })
  } else if (store.state.currentOrderTab === "Processing") {
    if (store.state.keyword) {
      await store.dispatch("handleOrderList", {
        page: store.state.currentOrderPage,
        orderStatus,
        keyword: store.state.keyword,
        ExcludePreOrderStatuses: [],
      })
    } else {
      await store.dispatch("handleOrderList", {
        page: store.state.currentOrderPage,
        orderStatus,
        keyword: store.state.keyword,
        ExcludePreOrderStatuses: [
          OrderStatus.Processing,
          OrderStatus.Ready,
          OrderStatus.Delivering,
        ],
      })
    }
  } else {
    await store.dispatch("handleOrderList", {
      page: store.state.currentOrderPage,
      orderStatus,
      keyword: store.state.keyword,
      ExcludePreOrderStatuses: [],
      // noReplaceOrderList: true
    })
  }
}

export const startSignalR = (merchId: string, token: string) => {
  if (store.state.initializingSignalR) {
    return
  }
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${window.config.netUrl}/merchantHub`, {
      accessTokenFactory: () => token,
    })
    .build()

  connection.on("onNewOrderReceived", async (event) => {
    // if (refreshTimeLimit()) {
    const orderStatus = getCurrentTabOrderStatus()
    if (store.state.inPreOrderTab && store.state.preOrderDate) {
      await store.dispatch("handlePreOrderList", {
        page: store.state.currentOrderPage,
        orderStatus,
        keyword: store.state.keyword,
        date: store.state.preOrderDate,
      })
      return
    }

    if (store.state.currentOrderTab === "Processing") {
      if (store.state.keyword) {
        await store.dispatch("handleOrderList", {
          page: store.state.currentOrderPage,
          orderStatus,
          keyword: store.state.keyword,
          ExcludePreOrderStatuses: [],
        })
      } else {
        await store.dispatch("handleOrderList", {
          page: store.state.currentOrderPage,
          orderStatus,
          keyword: store.state.keyword,
          ExcludePreOrderStatuses: [
            OrderStatus.Processing,
            OrderStatus.Ready,
            OrderStatus.Delivering,
          ],
        })
      }

      return
    }

    await store.dispatch("handleOrderList", {
      page: store.state.currentOrderPage,
      orderStatus,
      keyword: store.state.keyword,
      ExcludePreOrderStatuses: [],
    })
    // }
  })
  connection.on("onOrderStatusUpdated", async (event) => {
    // if (!refreshTimeLimit()) {
    //   return
    // }
    let oldOrderList = store.state.orderList
    handleOrderList()
    // refreshHistoryOrderList(event)

    // -------有人在上一页完成1张订单--------
    if (
      store.state.orderList.length > oldOrderList.length &&
      store.state.currentOrderTab !== "Completed"
    ) {
      let newOrderList = store.state.orderList
      newOrderList.splice(0, 1)
      store.commit("handleOrderList", newOrderList)
    }
    // --------------------------------

    // -------在complete页面，其他人complete了订单出现在浏览的页面中-------------
    if (
      store.state.orderList.length > oldOrderList.length &&
      store.state.currentOrderTab === "Completed"
    ) {
      let newOrderList = store.state.orderList
      newOrderList.pop()
      store.commit("handleOrderList", newOrderList)
    }
    // ---------------------------------
  })

  connection.on(
    "onGroupMerchantReceiveCustomerMessage",
    async (message: TrackableMessageDto, timeStamp: number) => {
      store.commit("handleNewMessageReceived", message)
      store.commit("handleImRequestTimeStamp", timeStamp)
      const requestParams: GetTotalUnReadCountRequest = {
        merchIds: [],
        orderIds: [],
        userIds: [],
        requestFrom: CommunicationParty.merchant,
      }
      if (!noRequestIMCountPages.includes(window.Vue._route.name)) {
        if (store.state.isPc) {
          requestParams.merchIds = store.state.merchIds
        }
        await getUnreadMessageCount(requestParams)
      }
    }
  )

  connection.on(
    "onGroupMerchantSyncMessage",
    (message: TrackableMessageDto, timeStamp: number) => {
      store.commit("handleNewMessageReceived", message)
      store.commit("handleImRequestTimeStamp", timeStamp)
      const requestParams: GetTotalUnReadCountRequest = {
        merchIds: [],
        orderIds: [],
        userIds: [],
        requestFrom: CommunicationParty.merchant,
      }
      if (!noRequestIMCountPages.includes(window.Vue._route.name)) {
        if (store.state.isPc) {
          requestParams.merchIds = store.state.merchIds
        }
        getUnreadMessageCount(requestParams)
      }
    }
  )

  connection.on("onMerchUpdated", (e) => {
    e.status = e.status ? 1 : 0
    e.autoAcceptOrder = !!e.auto_accept_order
    e["merchName"] = e.name
    e["merchAddress"] = e.address
    store.commit("handleLoginMerchant", e)
  })

  connection.on("onOrderRefunded", async (event) => {
    // refreshHistoryOrderList(event)
  })

  connection.on("onOrderCancellationAccepted", async (event) => {
    await store.dispatch("handleRefundOrderList")
    if (store.state.keyword || store.state.currentOrderTab === "Completed") {
      handleOrderList()
    }
    // refreshHistoryOrderList(event)
  })

  connection.on("onOrderCancellationRejected", async (event) => {
    await store.dispatch("handleRefundOrderList")
    if (store.state.keyword || store.state.currentOrderTab === "Completed") {
      handleOrderList()
    }
    // refreshHistoryOrderList(event)
  })

  // 商家收到退款申请, 商家cancell菜品
  connection.on("onOrderCancellationRequested", async (event) => {
    await store.dispatch("handleRefundOrderList")
    const orderStatus = getCurrentTabOrderStatus()
    if (store.state.inPreOrderTab && store.state.preOrderDate) {
      await store.dispatch("handlePreOrderList", {
        page: store.state.currentOrderPage,
        orderStatus,
        date: store.state.preOrderDate,
      })
      return
    }

    if (store.state.currentOrderTab === "Processing") {
      if (store.state.keyword) {
        await store.dispatch("handleOrderList", {
          page: store.state.currentOrderPage,
          orderStatus,
          keyword: store.state.keyword,
          ExcludePreOrderStatuses: [],
        })
      } else {
        await store.dispatch("handleOrderList", {
          page: store.state.currentOrderPage,
          orderStatus,
          keyword: store.state.keyword,
          ExcludePreOrderStatuses: [
            OrderStatus.Processing,
            OrderStatus.Ready,
            OrderStatus.Delivering,
          ],
        })
      }
    } else {
      await store.dispatch("handleOrderList", {
        page: store.state.currentOrderPage,
        orderStatus,
        keyword: store.state.keyword,
        ExcludePreOrderStatuses: [],
      })
    }

    // refreshHistoryOrderList(event)
  })

  connection.onclose(() => {
    store.commit("handleSignalRInitializingStatus", false)
    store.commit("handleSignalRConnectionChanged", false)
    // reconnect()
  })

  connection
    .start()
    .then((x) => {
      store.commit("handleSignalRInitializingStatus", false)
      connection.invoke("AddToGroup", merchId).then((x) => {
        store.commit("handleSignalRConnectionChanged", true)
      })
    })
    .catch((err) => {
      store.commit("handleSignalRInitializingStatus", false)
      store.commit("handleSignalRConnectionChanged", false)
      console.log(err)
    })

  function reconnect() {
    connection
      .start()
      .then(() => {
        connection.invoke("AddToGroup", merchId).then(() => {
          store.commit("handleSignalRConnectionChanged", true)
        })
      })
      .catch((err) => {
        store.commit("handleSignalRInitializingStatus", false)
        store.commit("handleSignalRConnectionChanged", false)
        console.log(err)
        setTimeout(() => {
          reconnect()
        }, 120000)
      })
  }
}
